import Vue from 'vue'
import Vuex from 'vuex'
import {documentTypesCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        data:{
          number:'',
          description:'',
          createdAt:'',
        },
        record:{},
        selectedKey: '',
        dialog: false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
          Vue.delete(state.record, key)
        }
      },
      actions: {
        getAll:(context)=>{
          context.state.record = {}
          documentTypesCollection.onSnapshot(data=>data.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
        },
        add:context=>{
          if(context.state.selectedKey==''){
            documentTypesCollection.add({...context.state.data, createdAt:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo tipo de moneda correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }else{
            documentTypesCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
          documentTypesCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
          documentTypesCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.data = {
            number: '',
            description: '',
            createdAt: ''
          }
        },
      },
      getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
      },
  }
  